import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './Components/store/store';
import AuthListener from './Components/Auth/AuthListener';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Provider store={store}>
        <AuthListener>
          <App />
        </AuthListener>
      </Provider>
    </React.StrictMode>
  </BrowserRouter>
);

